import { Table } from './Table';
import Markdown from 'markdown-to-jsx';
import type { ComponentProps } from 'react';
import { List } from '@zopauk/react-components';
import { TextLink } from '@/components/TextLink';

const overrides = {
  tick: ({ ...props }) => (
    <span {...props} className="material-symbols-outlined text-4xl! text-secondary !align-middle">
      check
    </span>
  ),
  cross: ({ ...props }) => (
    <span {...props} className="material-symbols-outlined text-4xl! !align-middle">
      close
    </span>
  ),
  h2: ({ ...props }) => (
    <h2 {...props} className={`text-4xl lg:text-5xl my-4 font-serif font-semibold ${props.className}`} />
  ),
  h4: ({ ...props }) => (
    <h4 {...props} className={`text-xl lg:text-2xl my-4 font-serif font-semibold ${props.className}`} />
  ),
  h3: ({ ...props }) => (
    <h3 {...props} className={`text-2xl lg:text-3xl font-serif font-semibold ${props.className}`} />
  ),
  h5: ({ ...props }) => <h5 {...props} className={`text-base lg:text-lg mb-4 font-semibold ${props.className}`} />,
  h6: ({ ...props }) => <h6 {...props} className={`text-sm lg:text-base font-semibold ${props.className} mb-2`} />,
  h1: ({ ...props }) => <h1 {...props} className={`text-7xl mb-5 font-serif font-semibold ${props.className}`} />,
  a: ({ ...props }) => (
    <TextLink href={props.href} {...props}>
      {props.children}
    </TextLink>
  ),
  // `<table data-layout="comparison">` opts a table into the comparison layout.
  table: ({ 'data-layout': layout, ...props }: { 'data-layout'?: string } & ComponentProps<'table'>) => (
    <Table className={layout === 'comparison' ? 'comparison-table' : undefined}>
      <table {...props} />
    </Table>
  ),
  p: ({ ...props }) => <p {...props} className="mb-6" />,
  ol: ({ ...props }) => <List as="ol" {...props} />,
  ul: ({ ...props }) => <List as="ul" {...props} />,
  strong: ({ ...props }) => <strong {...props} />,
  li: ({ ...props }) => <List.Item {...props} />,
};

export const MarkdownToJSX = ({ md }: Record<'md', string>) => (
  // markdown-to-jsx v8+ decodes all standard named HTML entities (incl. &pound;) natively,
  // so the previous `namedCodesToUnicode: { pound: '\u00A3' }` mapping is no longer needed.
  <Markdown options={{ forceBlock: true, overrides }}>{md}</Markdown>
);
